import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { requestLoginRedirect } from '../auth/login-redirect';
import { AuthService } from '../auth/auth.service';

// On a 401 from the API (expired session the refresh could not save, revoked user), drop the dead
// session and land on OUR login page instead of leaving the user on a page full of "Unauthorized"
// errors. The cooldown guard stays: a 401 a fresh login cannot fix (an account with no access)
// must surface as a visible error, not a navigation loop. The auth endpoints themselves are
// exempt — a wrong password is the LOGIN PAGE's error to show inline.
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
    // The auth endpoints are exempt — checked BEFORE any inject(): these requests can fire while
    // AuthService is still constructing (the Google redirect exchange), and injecting it here at
    // that moment is a circular dependency (NG0200) that kills the request without a trace.
    if (req.url.includes('/central/auth/')) {
        return next(req);
    }
    const router = inject(Router);
    const auth = inject(AuthService);
    return next(req).pipe(
        catchError((err) => {
            if (err instanceof HttpErrorResponse && err.status === 401
                && requestLoginRedirect(`401 from ${req.method} ${req.url}`)) {
                auth.signOut();
                router.navigate(['/auth/login']);
            }
            return throwError(() => err);
        })
    );
};
